<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <b-modal v-model="modal" title="Ingreso a calidad" centered size="lg">
      <div>
        <p style="font-weight: 600">¿El paquete cumple con los estándares de calidad?</p>
      </div>
      <b-row>
        <b-col>
          <b-form-group class="d-flex justify-content-center mt-3" v-slot="{ ariaDescribedby }">
            <b-form-radio-group
                id="radio-group-2"
                v-model="form.aceptado"
                :aria-describedby="ariaDescribedby"
                name="radio-sub-component"
            >
              <b-form-radio :value="true">Sí</b-form-radio>
              <b-form-radio :value="false">No</b-form-radio>
            </b-form-radio-group>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row  class="d-flex justify-content-center mt-2" v-if="form.aceptado === false">
        <b-col cols="8">
          <p> Motivo </p>
          <v-select
              v-model="form.motivo"
              label="descripcion"
              :options="devoluciones"
              :reduce="(i) => i.idDevolucionLaboratorio"
          >
          </v-select>
        </b-col>
      </b-row>

      <div slot="modal-footer">
        <b-button
          style="margin-right: 40px"
          variant="outline-primary"
          :disabled="loaderAcciones"
          @click="enviar()"
        >
          <span v-if="!loaderAcciones">Guardar</span>
          <span v-if="loaderAcciones">
            <b-spinner small></b-spinner>
            Cargando...
          </span>
        </b-button>
        <b-button
          variant="outline-danger"
          :disabled="loaderAcciones"
          @click="modal = false"
          >Cancelar</b-button
        >
      </div>
    </b-modal>
  </div>
</template>

<script>
import {LaboratorioService} from "../../apiServices/laboratorio/LaboratorioService";

export default {
  name: "IngresoCalidad",
  components: {},
  props: {
    parametros: null,
  },
  data: () => {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,

      modal: true,
      laboratorioServicio: new LaboratorioService(),
      form: {
        aceptado: null,
        motivo: null
      },
      devoluciones: [],
      idSolicitud: null,
      idEtapa: null,
      loaderAcciones: false

    }
  },
  created() {
    this.debug = this.$localStorageService.getDebug();

    this.idSolicitud = this.parametros[0].idSolicitud
    this.idEtapa = this.parametros[0].idEtapa
    this.obtenerDevoluciones();
  },
  methods: {
    obtenerDevoluciones() {
      this.laboratorioServicio.obtenerDevoluciones().then(
          response => {
            this.devoluciones = response.data
          })
    },
    enviar() {
      this.loaderAcciones = true
      this.laboratorioServicio.aceptarDenegarODT(this.idSolicitud, this.idEtapa, this.form).then(
          () => {
            this.$swal({
              icon: "success",
              title: "Se registro correctamente",
              showConfirmButton: false
            });
            // this.$v.$reset()
            location.reload();
          }).finally(() => {
            this.loaderAcciones = false
      })
    }
  }
}
</script>

<style scoped>

</style>
